import type { Uuid } from '@cyphex/types/common';

/**
 * Platform query keys.
 *
 * A tree of its own rather than a branch of ADMIN_KEYS: the composer's command
 * registry and the "..." menu read from here on every channel open, and they
 * must not be swept away every time an operator saves something in the console.
 */
export const PLATFORM_KEYS = {
  all: ['platform'] as const,

  apps: () => [...PLATFORM_KEYS.all, 'apps'] as const,
  app: (appId: Uuid) => [...PLATFORM_KEYS.apps(), appId] as const,

  tokens: () => [...PLATFORM_KEYS.all, 'tokens'] as const,
  webhooks: () => [...PLATFORM_KEYS.all, 'webhooks'] as const,

  subscriptions: () => [...PLATFORM_KEYS.all, 'subscriptions'] as const,
  deliveries: (subscriptionId: Uuid, status: string) =>
    [...PLATFORM_KEYS.subscriptions(), subscriptionId, 'deliveries', status] as const,

  /** Everything a member may see. Managed commands live under `managedCommands`. */
  commands: () => [...PLATFORM_KEYS.all, 'commands'] as const,
  managedCommands: () => [...PLATFORM_KEYS.all, 'commands', 'managed'] as const,

  messageActions: () => [...PLATFORM_KEYS.all, 'message-actions'] as const,
  managedMessageActions: () => [...PLATFORM_KEYS.all, 'message-actions', 'managed'] as const,

  tabCatalogue: (channelId: Uuid) =>
    [...PLATFORM_KEYS.all, 'tab-catalogue', channelId] as const,
} as const;
